import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import { NotFoundScreen } from './App';
import Settings from './components/Settings';
import ConfirmLocation from './components/ConfirmLocation';
import { messaging } from './libs/firebase/messaging-init';
import * as serviceWorker from './serviceWorker';

// React Router
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

if ('serviceWorker' in navigator && messaging) {
    navigator.serviceWorker.register('/firebase-messaging-sw.js');
}

const root = (
    <React.StrictMode>
        <Router>
            <Switch>
                {/* Legacy redirects (no country code) */}
                <Route
                    exact
                    path="/settings/:deliveryId"
                    render={({ match }) => (
                        <Redirect to={`/us/settings/${match.params.deliveryId}`} />
                    )}
                />
                <Route
                    exact
                    path="/:deliveryId"
                    render={({ match }) => (
                        <Redirect to={`/us/${match.params.deliveryId}`} />
                    )}
                />
                <Route
                    exact
                    path="/:countryCode/settings/:deliveryId"
                    component={Settings}
                />
                <Route
                    exact
                    path="/:countryCode/confirm-location/:deliveryId"
                    component={ConfirmLocation}
                />
                <Route exact path="/:countryCode/:deliveryId" component={App} />
                <Route component={NotFoundScreen} />
            </Switch>
        </Router>
    </React.StrictMode>
);

const container = document.getElementById('root');
const rootTree = createRoot(container);
rootTree.render(root);

serviceWorker.unregister();
